export default __webpack_public_path__ + "static/1731-ce69e04bb653794051901a05900f1142.gif";